





















































































import {Prop, Component, Emit, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Mutation, namespace, Getter, State} from 'vuex-class';
import BTable from 'buefy/src/components/table/Table.vue';
import {MAFViolation} from '@/store/Violations/types';
import {ReviewRate} from '@/store/RateReviewFaq/types';
import { CommentQue } from '../../store/RateReviewFaq/types';
import moment from 'moment';
import { MAFUser } from '../../store/User/types';

/* tslint:disable:max-line-length */

const violationPath = 'violationState';
const violationNamespace = namespace(violationPath);
const userPath = 'userState';
const userNamespace = namespace(userPath);
const reviewsPath = 'rateState';
const reviewsNamespace = namespace(reviewsPath);
const commentsPath = 'rateState';
const commentsNamespace = namespace(commentsPath);

@Component({
  components: {
    BTable,
  },
})

 export default class Reporting extends Vue {
    @violationNamespace.State('allUsers') public Users !: MAFUser[];
    @violationNamespace.Action('getAllUsers') public getAllUsers!: any;
    @violationNamespace.Action('getMAFViolations') public getMAFViolations: any;
    @violationNamespace.State('violations') public Violations!: MAFViolation[];
    @reviewsNamespace.Action('getReviews') public getReviews: any;
    @reviewsNamespace.State('reviewRate') public Reviews!: ReviewRate[];
    @commentsNamespace.Action('getComments') public getComments: any;
    @commentsNamespace.State('commentsQues') public Comments!: CommentQue[];

    get admin() {
      if (this.Users) {
        return this.Users.filter((u) => u.isAdmin);
      }
    }

    get banned() {
      if (this.Users) {
        return this.Users.filter((u) => u.isBanned);
      }
    }

    get incomplete() {
      if (this.Users) {
        return this.Users.filter((u) => u.signUpPhase !== -1);
      }
    }

    get todaysUsers() {
      if (this.Users) {
        const today = moment().startOf('day');
        return this.Users.filter((u) => moment(u.termsAgreedOn).startOf('day').isSame(today, 'd'));
      }
    }
    get generalUsers() {
      if (this.Users) {
        const user = 'General User';
        const user2 = 'Me and a Caregiver';
        const user3 = 'Me and Parents';
        const user4 = 'Me';
        return this.Users.filter((u) => u.userType === user || u.userType === user2 || u.userType === user3 || u.userType === user4);
      }
    }
    get parentUsers() {
      if (this.Users) {
        const parent = 'Parent/Caregiver';
        const par2 = 'A Caregiver';
        const par3 = 'My Parents';
        return this.Users.filter((u) => u.userType === parent || u.userType === par2 || u.userType === par3);
      }
    }

    get organizationUsers() {
      if (this.Users) {
        return this.Users.filter((u) => u.userType === 'Organization');
      }
    }

    get loggedInToday() {
      if (this.Users) {
        const today = moment().startOf('day');
        return this.Users.filter((u) => moment(u.lastLogin).startOf('day').isSame(today, 'd'));
      }
    }

    get diagnosees() {
      if (this.Users) {
        const reducedUsers = this.Users.reduce((obj: any, user: MAFUser) => {
          if (user.userType === 'Parent/Caregiver' || user.userType === 'A Caregiver' || user.userType === 'My Parents') {
            user.diagnosis = 'N/A - Caregiver';
          } else if (user.diagnosis === undefined) {
            user.diagnosis = 'N/A - Not Provided';
          }

          const severity = +(user.severity || '0') || 0;
          if (obj[user.diagnosis!]) {
            obj[user.diagnosis!].count += 1;
            obj[user.diagnosis!].totalSeverity += severity;
          } else {
            obj[user.diagnosis!] = { type: user.diagnosis, count: 1, totalSeverity: severity };
          }
          if (user.diagnosis.includes('N/A')) {
            obj[user.diagnosis].totalSeverity = 'N/A';
          }
          return obj;
        }, {});

        const usersToArray = Object.values(reducedUsers);
        return usersToArray.sort((a: any, b: any) => (a.count < b.count) ? 1 : ((b.count < a.count) ? -1 : 0));
      }
      return [];
    }

    get rating() {
      if (this.Reviews) {
        const totalReview = this.Reviews.reduce((total, r) => total + (+r.rate), 0);
        const reviewAvg = totalReview / this.Reviews.length;
        return Math.round( reviewAvg * 10 ) / 10;
      }
    }

    get unresolvedViolations() {
      if (this.Violations) {
        return this.Violations.filter((v) => v.resolution === '').length;
      }
      return 0;
    }

    get resolvedViolations() {
      if (this.Violations) {
        return this.Violations.filter((v) => v.resolution !== '').length;
      }
      return 0;
    }

    get resolvedComments() {
      if (this.Comments) {
        return this.Comments.filter((c) => c.resolved).length;
      }
      return 0;
    }

    public async created() {
      await this.getReviews();
      await this.getComments();
      await this.getMAFViolations();
    }

    public getReviewCount( rating: number ) {
      if (this.Reviews) {
        return this.Reviews.filter((r) => r.rate === rating).length;
      }
      return 0;
    }

    public arr2csv = (arr: any) =>
      [Object.keys(arr[0]).join(','), ...arr.map( (a: any) => Object.values( a ).join(','))].join('\n')

    public runReport( type: string ) {
      let csvContent = '';
      if (type === 'users') {
        csvContent = this.arr2csv(this.cleanUsers());
      } else if (type === 'violations') {
        csvContent = this.arr2csv(this.cleanViolations());
      } else if (type === 'helpRequests') {
        csvContent = this.arr2csv(this.cleanHelpRequest());
      }

      // download the CSV
      const hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent);
      hiddenElement.target = '_blank';
      hiddenElement.download = `${type}.csv`;
      hiddenElement.click();
    }

    public cleanUsers(): any[] {
      // // report for LA users (zipcodes 90001 to 90899)
      // // if they have a zip and the zip is a valid number in LA range
      // return this.Users.filter(u => u.zipCode && !isNaN(+u.zipCode) && +u.zipCode >= 90001 && +u.zipCode <= 90899).map( (user) => ({
      //   name: user.name,
      //   email: user.email,
      //   isBanned: user.isBanned,
      //   birthdate: moment(user.birthdate).format('MM/DD/YYYY'),
      //   role: user.userType, // TODO: if this gets used again, parse this into the two main roles
      //   diagnosis: (user.diagnosis) ? user.diagnosis.replace(/,/g, '+') : ' ',
      //   otherdiagnosis: (user.otherdiagnosis) ? user.otherdiagnosis.replace(/-/g, '').replace(/,/g, '+') : ' ',
      //   zipcode: user.zipCode,
      // })).sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

      return this.Users.map( (user) => ({
        uid: user.uid,
        name: user.name,
        email: user.email,
        coins: user.coins,
        isAdmin: user.isAdmin,
        isBanned: user.isBanned,
        first500: user.first500,
        birthdate: moment(user.birthdate).format('MM/DD/YYYY'),
        termsAgreedOn: user.termsAgreedOn,
        lastLogin: user.lastLogin,
        diagnosis: (user.diagnosis) ? user.diagnosis.replace(/,/g, '+') : ' ',
        otherdiagnosis: (user.otherdiagnosis) ? user.otherdiagnosis.replace(/-/g, '').replace(/,/g, '+') : ' ',
        severity: user.severity,
        zipcode: user.zipCode,
        interests: (user.interests) ? user.interests.join('+') : '',
        groupInterests: (user.groupInterests) ? user.groupInterests.join('+') : '',
        avatarUrl: user.avataarUrl,
        imageUrl: user.imageURL,
        latitude: (user.location) ? user.location.latitude : undefined,
        longitude: (user.location) ? user.location.longitude : undefined,
      }));
    }

    public cleanViolations(): any[] {
      return this.Violations.map( (v) => ({
        offenderId: (v.user_reported && v.user_reported.uid) ? v.user_reported.uid : '',
        offenderName: (v.user_reported && v.user_reported.name) ? v.user_reported.name : '',
        offenderEmail: (v.user_reported && v.user_reported.email) ? v.user_reported.email : '',
        issueReported: (v.issue_reported) ? v.issue_reported : '',
        date: v.date,
        reporterId: (v.reporter && v.reporter.uid) ? v.reporter.uid : '',
        reporterName: (v.reporter && v.reporter.name) ? v.reporter.name : '',
        reporterEmail: (v.reporter && v.reporter.email) ? v.reporter.email : '',
        resolution: v.resolution,
      }));
    }

    public cleanHelpRequest(): any[] {
      return this.Comments.map( (c) => ({
        userId: (c.User) ? c.User.uid : '',
        userName: (c.User) ? c.User.name : '',
        userEmail: (c.User) ? c.User.email : '',
        date: c.date,
        resolved: (c.resolved) ? c.resolved : false,
        comment: c.comment.replace(/,/g, '.'),
      }));
    }
 }
